import { setRangeMax } from './helpers';

export const setMaxArea = setRangeMax('total_area');
